export enum ETrainingType {
  RECCURENT = 'Recurrent',
  INITIAL = 'Initial',
  SIMULATOR = 'Simulator',
}
